import React from "react"
import './team.scss';

import joan from '../../assets/team/Joan_Tretze.png';
import joanB from '../../assets/team/01d13.jpg';
import laurielle from '../../assets/team/Laurielle.png';
import laurielleB from '../../assets/team/02Laurielle.jpg';
import loman from '../../assets/team/Loman.png';
import loamB from '../../assets/team/03Loman.jpg';
import moran from '../../assets/team/Moran.png';
import moranB from '../../assets/team/04Morán.jpg';
import triassicLogo from '../../assets/triassicpark-logo-S.png';
import desaparecido from '../../assets/desaparecido.png';

const teamMembers = [
    {
        front: {
            image: joan,
            name: 'Federico Macías',
            number: '001',
            arquetype: 'Poli',
            department: 'Seguridad',
            color: 'royalblue',
            coñas: 'Amigotes, No hay dolor, Asesino nato',
            tara: 'Fobia al número 13'
        },
        back: {
            imageB: joanB,
            nameB: 'Joan Tretze',
            description: 'Autor del webcómic de culto El Sistema D13',
            link: 'elsistemad13.com',
        }
    },
    {
        front: {
            image: laurielle,
            name: 'Margarita Ferrán',
            number: '002',
            arquetype: 'Megafan',
            department: 'Negocio',
            color: 'goldenrod',
            coñas: 'Fangirlismo, Enciclopedia viviente, Suerte',
            tara: 'Despistado',
        },
        back: {
            imageB: laurielleB,
            nameB: 'Laurielle',
            description: 'Autora de cómics como La Taza Medio Llena, Nada del Otro Mundo o Asalto al Castillo. Coautora en El Vosque. Zombie en los ratos libres | Ella/She/Her',
            link: 'linktr.ee/laurielle',
        }
    },
    {
        front: {
            image: loman,
            name: 'Dr. Gervasio Mazarrones',
            number: '003',
            arquetype: 'Cerebrito',
            department: 'Genética',
            color: 'indianred',
            coñas: 'Eureka, Bolsillazos, McGyver',
            tara: 'Cenizo',
            missing: true,
        },
        back: {
            imageB: loamB,
            nameB: 'Álvaro Loman',
            description: 'Rolero de pro (con carné). COMPRA MI LIBRO.',
            link: 'alvaroloman.com',
        }
    },
    {
        front: {
            image: moran,
            name: 'xXKike99Xx',
            number: '004',
            arquetype: 'Influencer',
            department:'Marqueting',
            color: 'teal',
            coñas: 'Mis dieses, Popularidad, Superatributo',
            tara: 'Paranoia',
        },
        back: {
            imageB: moranB,
            nameB: 'Sergio S. Morán',
            description: 'Autor de la saga Parabellum y Enseñanza Mágica Obligatoria. Cazadragones sin licencia. Coautor en El Vosque',
            link: 'sergiomoran.es',
        }
    },
];      


function Team() {

    const card = (member) => {
        const { front, back } = member;
        const {image, name, number, arquetype, department, color, coñas, tara, missing} = front;
        const {imageB, nameB, description, link} = back;

        return (
            <li className="card">
                <div className="back">
                    <div className="card-hole"/>
                    <div className="photo-container">
                        <img src={imageB} height={170} alt="portrait of the team member"/>
                    </div>
                    <table>
                        <tbody>
                                <tr>
                                    <td className="title">Nombre</td>
                                    <td className="data">{nameB}</td>
                                </tr>
                                <tr>
                                    <td className="title">Descripción</td>
                                    <td className="data">{description}</td>
                                </tr>
                                <tr>
                                    <td className="title">Link</td>
                                    <td className="data"><a href={link} target="blank">{link}</a></td>
                                </tr>
                        </tbody>
                    </table>

                </div>
                <div className="front">
                    <div className="card-hole"/>
                    <div className="photo-container">
                        <img src={image} height={170} alt="portrait of the team member"/>
                    </div>
                    <table>
                        <tbody>
                            <tr>
                                <td className="title">Nombre</td>
                                <td className="data">{name}</td>
                            </tr>
                            <tr>
                                <td className="number" colSpan={2}><small>Nº Empleado: {number}</small><br/></td>
                            </tr>
                            <tr>
                                <td className="title">Arquetipo</td>
                                <td className="data">{arquetype}</td>
                            </tr>
                            <tr>
                                <td className="title">Coñas</td>
                                <td className="data">{coñas}</td>
                            </tr>
                            <tr>
                                <td className="title">Tara</td>
                                <td className="data">{tara}</td>
                            </tr>
                        </tbody>
                    </table>
                    <p className="card-footer" style={{backgroundColor: color}}>{department}</p>
                    <img className="card-logo" src={triassicLogo} height={60} alt="logo de Triassic Park"/>
                   { missing && <img className="missing" src={desaparecido} height={200} alt="desaparecido"/>}
                </div>
            </li>
        );
    }

    const cards = teamMembers.map((member) => card(member));

    return (
        <section id="equipo" className="scroller">
            <h3>Equipo</h3>
            <div className="background">
                <article>
                    <h4>¡Conoce a nuestros profesionales!</h4>
                    <p>
                        Contamos con los más notables y experimentados expertos para convertir Triassic Park en una experiencia inolvidable.
                    </p>
                    <ul className="cards-container">
                        {cards}
                    </ul>
                </article>
                
            </div>
        </section>
    );
}

export default Team;
